import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./i18n/config"
import App from "./App";

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.querySelector("#root")
);
